import React, {Component} from "react";
import {connect} from "react-redux";
import Table from "../../../components/Table";
import ServiceItem from "./ServiceItem";
import Loading from "../../../components/Loading";
import GraphQLErrors from "../../../components/GraphQLErrors";
import {fromJS, List} from "immutable";
import {graphql} from "react-apollo";
import gql from "graphql-tag";

class ServicesList extends Component {

  componentDidMount() {
    this.props.subscribeToUpdates(this.props, {});
  }

  render() {
    let {loading, error, infrastructureServices} = this.props.data;
    if (loading) return <Loading />
    if (error) return <GraphQLErrors error={error} />

    let tableHeader = List([
      "Description",
      "Status"
    ])
    return (
      <Table 
        data={fromJS(infrastructureServices)} 
        renderer={ServiceItem} 
        tableHeader={tableHeader}
        onItemClick={this.handleItemClick.bind(this)}
        selected={this.props.selectedId}
        mode="table"
        itemKey="serviceId"
        />
    )
  }

  handleItemClick(itemData, e, field) {
    this.props.onSelectionChange(itemData);
  }  
}

const GET_SERVICES = gql`
  query infrastructureServices{
    infrastructureServices{
      serviceId
      title
      description
      status
      tags
    }
  }
`

const ON_UPDATED_SERVICE = gql`
  subscription onUpdatedService {
    updatedService {
      serviceId
      status
    }
  }  
`

const mapDispatchToProps = dispatch => ({
  subscribeToUpdates: (props, params) => {
    return props.data.subscribeToMore({
      document: ON_UPDATED_SERVICE,
      updateQuery: (prev, { subscriptionData }) => {
        props.data.refetch();
        return prev;
      }
    })
  }
})

const withQuery = graphql(GET_SERVICES, {
  options: (props) => ({
    fetchPolicy: "network-only"
  })
})

export default connect(null, mapDispatchToProps)(withQuery(ServicesList));